const initialPaging = {
  page: 1,
  sizePerPage: 10,
  sortField: '',
  sortOrder: '',
};

export const initialFields = {
  includedTeam: 'true',
  keywords: '',
  statusOptions: 'O',
  typeOptions: '',
  createdFrom: '',
  createdTo: '',
  completedFrom: '',
  completedTo: '',
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'changeProducer':
      return {
        paging: initialPaging,
        fields: initialFields,
        queryParams: {
          ...initialPaging,
          ...initialFields,
          ...action.payload,
        },
      };
    case 'submit':
      return {
        ...state,
        paging: initialPaging,
        queryParams: {
          ...state.queryParams,
          ...state.fields,
          ...initialPaging,
        },
      };
    case 'changePaging':
      return {
        ...state,
        paging: {...state.paging, ...action.payload},
        queryParams: {
          ...state.queryParams,
          ...action.payload,
        },
      };
    case 'changeFields':
      return {
        ...state,
        fields: {
          ...state.fields,
          ...action.payload,
        },
      };
    default:
      throw new Error();
  }
};

export const getInitialState = producer => ({
  paging: initialPaging,
  fields: initialFields,
  queryParams: {
    ...initialPaging,
    ...initialFields,
    manager: producer.producerFullName,
    selectedProducerId: producer.producerId,
  },
});

export default reducer;
